import { TypedDefinition } from '@rehaje/core'

import type { URLParameterPlugin } from './plugin'
import type { TypedSchema } from '@rehaje/core'

export class URLParameterDefinition extends TypedDefinition {
  override properties: TypedSchema[] = []
  get plugin() {
    return this.getPlugin<URLParameterPlugin>()
  }

  constructor() {
    super()
    this.properties = [
      {
        name: 'type',
        type: 'Schema.String'
      },
      {
        name: 'id',
        type: 'Schema.String'
      },
      {
        name: 'name',
        type: 'Schema.Union',
        types: [
          {
            expect: {
              type: 'Schema.String'
            },
            type: 'Schema.Mustache'
          },
          {
            type: 'Schema.String'
          }
        ]
      },
      {
        name: 'value',
        type: 'Schema.Union',
        types: [
          {
            expect: {
              type: 'Schema.String'
            },
            type: 'Schema.Mustache'
          },
          {
            type: 'Schema.String'
          }
        ]
      }
    ]
  }
}
